import { Box, styled, Typography } from '@mui/material';

export const FlexCenterBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
}));

export const FlexBetweenBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
}));

export const FlexEndBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',
}));

export const FlexStartBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'flex-start',
}));

export const FlexColumnBox = styled(Box)(
  ({ theme, alignItems = 'center' }) => ({
    display: 'flex',
    alignItems,
    flexDirection: 'column',
    justifyContent: 'center',
  })
);

export const StyledFieldErrorMessage = styled(Typography)(({ theme }) => ({
  marginTop: '3px',
  fontSize: '12px',
  textAlign: 'start',
  color: theme.palette.error.main,
}));

export const StyledStatus = styled(Box)(
  ({ theme, circleColor, color, bgcolor }) => ({
    color: color,
    fontWeight: 500,
    fontSize: '14px',
    borderRadius: 16,
    background: bgcolor,
    padding: '4px 12px',
    fontFamily: 'Manrope',
    display: 'inline-block',
    '&::before': {
      width: '8px',
      content: '""',
      height: '8px',
      marginRight: '8px',
      borderRadius: '50%',
      backgroundColor: circleColor || color,
      display: 'inline-block',
    },
  })
);

export const StyledTextarea = styled(Box)(({ theme }) => ({
  width: '100%',
  '.MuiInputBase-root': {
    alignItems: 'flex-start',
    '& textarea': {
      height: '108px !important',
      overflow: 'auto !important',
      '&::-webkit-scrollbar': {
        width: '3px',
        height: '3px',
      },
      '&::-webkit-scrollbar-thumb': {
        borderRadius: '10px',
      },
    },
  },
}));
